import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'uploadingFileStatusToLabel'
})
export class UploadingFileStatusToLabelPipe implements PipeTransform {

  transform(value: any): string {
    const uploadLabel = 'Uploading...';
    const anonLabel = 'Anonymizing...';


    const types = Object.keys(value).map( item => value[item].type);
    if (types.includes('media-file')) {
      return uploadLabel;
    } else {
      return Object.keys(value).map( item => value[item].processing).every(item => item > 0.01) ? uploadLabel : anonLabel;
    }
  }

}
